<template>
  <div class="page-main dark-mode">
  <div class="address-book">
    <h1>Carnet d’adresses</h1>

    <div v-if="loading">Chargement des adresses...</div>

    <div v-else>
      <section class="default-addresses">
        <div class="address-block">
          <h2>Adresse de facturation par défaut</h2>
          <div v-if="facturation">
            <p><strong>{{ facturation.prefix }} {{ facturation.firstName }} {{ facturation.lastName }}</strong></p>
            <p>{{ facturation.company }}</p>
            <p>{{ facturation.address }}</p>
            <p>{{ facturation.city }}, {{ facturation.postalCode }}</p>
            <p>{{ facturation.country }}</p>
            <p>T: {{ facturation.phoneNumber }}</p>
            <button @click="editAddress(facturation)">Modifier l’adresse de facturation</button>
          </div>
        </div>

        <div class="address-block">
          <h2>Adresse de livraison par défaut</h2>
          <div v-if="livraison">
            <p><strong>{{ livraison.prefix }} {{ livraison.firstName }} {{ livraison.lastName }}</strong></p>
            <p>{{ livraison.company }}</p>
              <p>{{ livraison.address }}</p>
            <p>{{ livraison.city }}, {{ livraison.postalCode }}</p>
            <p>{{ livraison.country }}</p>
            <p>T: {{ livraison.phoneNumber }}</p>
            <button @click="editAddress(livraison)">Modifier</button>
          </div>
        </div>
      </section>

      <section class="extra-addresses">
        <h2>Saisies d’adresses supplémentaires</h2>
        <div v-if="otherAddresses.length">
          <ul>
            <li v-for="(addr, index) in otherAddresses" :key="index">
              <p>{{ addr.firstName }} {{ addr.lastName }} - {{ addr.address }} ({{ addr.city }})</p>
            </li>
          </ul>
        </div>
        <div v-else>
          <p>Vous n’avez pas d’autres adresses dans votre carnet d’adresses.</p>
        </div>
        <button @click="showForm = true">Ajouter une nouvelle adresse</button>
      </section>

      <div v-if="showForm" class="form-section">
        <h3>{{ editingAddress ? 'Modifier l’adresse' : 'Nouvelle adresse' }}</h3>
        <form @submit.prevent="saveAddress">
          <input v-model="form.prefix" placeholder="Civilité" />
          <input v-model="form.firstName" placeholder="Prénom" />
          <input v-model="form.lastName" placeholder="Nom" />
          <input v-model="form.phoneNumber" placeholder="Téléphone" />
          <input v-model="form.company" placeholder="Société" />
          <input v-model="form.address" placeholder="Adresse" />
          <input v-model="form.city" placeholder="Ville" />
          <input v-model="form.postalCode" placeholder="Code postal" />
          <input v-model="form.country" placeholder="Pays" />
          <button type="submit">Enregistrer</button>
          <button @click="cancelEdit">Annuler</button>
        </form>
      </div>
      <div v-if="toastMessage" :class="['toast', { error: toastError }]">
  {{ toastMessage }}
</div>

    </div>

  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      facturation: null,
      livraison: null,
      otherAddresses: [],
      form: {
        prefix: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        company: '',
        address: '',
        city: '',
        postalCode: '',
        country: '',
        type: '', // <-- ajout pour différencier facturation / livraison
      },
      showForm: false,
      editingAddress: null,
      loading: true,
      toastMessage: '',
      toastError: false,
    };
  },

  async mounted() {
    await this.fetchAddresses();
  },

  methods: {
    /** 🔹 Récupération des adresses de l'utilisateur */
    async fetchAddresses() {
      this.loading = true;
      const token = sessionStorage.getItem("token");
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (!user || !token) {
        this.loading = false;
        return;
      }

      try {
        const res = await fetch(`http://localhost:2028/api/addresses/user/${user._id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();

        if (Array.isArray(data) && data.length > 0) {
          this.facturation = data.find(a => a.type === "facturation") || data[0];
          this.livraison = data.find(a => a.type === "livraison") || data[0];
          this.otherAddresses = data.filter(a => a.type === "autre");
        } else {
          // Si aucune adresse, utiliser les infos du profil
          this.facturation = {
            prefix: user.civilite,
            firstName: user.prenom,
            lastName: user.nom,
            phoneNumber: user.telephone,
            company: user.societe,
            address: user.adresse,
            city: user.ville,
            postalCode: user.codePostal,
            country: user.pays,
            type: "facturation",
          };
          this.livraison = { ...this.facturation, type: "livraison" };
        }
      } catch (error) {
        console.error("Erreur de récupération d'adresses :", error);
      }

      this.loading = false;
    },

    /** 🔹 Ouvre le formulaire d’édition */
    editAddress(address) {
      this.editingAddress = address;
      this.form = { ...address };
      this.showForm = true;
    },

    /** 🔹 Annule l'édition */
    cancelEdit() {
      this.showForm = false;
      this.editingAddress = null;
      this.resetForm();
    },

async saveAddress() {
  const token = sessionStorage.getItem("token");
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (!user || !token) return;

  const isExisting = this.editingAddress && this.editingAddress._id;

  const method = isExisting ? "PUT" : "POST";
  const url = isExisting
    ? `http://localhost:2028/api/addresses/${this.editingAddress._id}`
    : `http://localhost:2028/api/addresses`;

  const addressData = {
    ...this.form,
    userId: user._id,
    type: this.editingAddress?.type || "facturation", // par défaut facturation
  };

  try {
    const res = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(addressData),
    });

    const savedAddress = await res.json();

    if (res.ok) {
      // ✅ Mise à jour du sessionStorage
      const updatedUser = { ...user };

      // On met à jour les mêmes champs que Account.vue utilise
      updatedUser.adresse = savedAddress.address;
      updatedUser.ville = savedAddress.city;
      updatedUser.codePostal = savedAddress.postalCode;
      updatedUser.pays = savedAddress.country;
      updatedUser.telephone = savedAddress.phoneNumber;
      updatedUser.societe = savedAddress.company;

      sessionStorage.setItem("user", JSON.stringify(updatedUser));

      // ✅ Déclenche l’événement pour Account.vue
      window.dispatchEvent(new CustomEvent("addressUpdated"));

      this.showToast(isExisting ? "Adresse modifiée !" : "Adresse ajoutée !");
      await this.fetchAddresses();
      this.cancelEdit();
    } else {
      console.error("Erreur API:", savedAddress.message || "Erreur inconnue");
      this.showToast("Erreur lors de la sauvegarde", true);
    }
  } catch (error) {
    console.error("Erreur de communication API:", error);
    this.showToast("Erreur réseau ou serveur", true);
  }
},


    /** 🔹 Réinitialisation du formulaire */
    resetForm() {
      this.form = {
        prefix: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        company: '',
        address: '',
        city: '',
        postalCode: '',
        country: '',
        type: '',
      };
    },

    /** 🔹 Toast de confirmation ou d’erreur */
    showToast(message, isError = false) {
      this.toastMessage = message;
      this.toastError = isError;
      setTimeout(() => {
        this.toastMessage = "";
      }, 3000);
    },
  },
};
</script>


<style scoped>
/* Mode clair par défaut */
.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #00998b;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  z-index: 9999;
  animation: slideDown 0.4s ease;
}

.toast.error {
  background-color: #e74c3c;
}

.address-book {
  padding: 20px;
  color: #333;
}

.address-block {
  margin-bottom: 30px;
  background: #f7f7f7;
  padding: 20px;
  border-radius: 10px;
}

button {
  margin-top: 10px;
  margin-right: 10px;
  padding: 6px 12px;
  border: none;
  background-color: #00998b;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #007f73;
}

.form-section {
  margin-top: 20px;
  background: #f0f0f0;
  padding: 20px;
  border-radius: 10px;
}

input {
  display: block;
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  color: #333;
  background-color: #fff;
}

/* Mode sombre automatique (basé sur le système) */
@media (prefers-color-scheme: dark) {
  .toast {
    background-color: #00bfa5;
    color: #fff;
  }
  .toast.error {
    background-color: #c0392b;
  }
  .address-book {
    background-color: #121212;
    color: #e0e0e0;
  }
  .address-block {
    background: #1e1e1e;
    border: 1px solid #333;
    color: #e0e0e0;
  }
  button {
    background-color: #00bfa5;
    color: #fff;
  }
  button:hover {
    background-color: #00998b;
  }
  .form-section {
    background: #1e1e1e;
    color: #f0f0f0;
    border: 1px solid #333;
  }
  input {
    background-color: #2b2b2b;
    color: #f0f0f0;
    border: 1px solid #555;
  }
  input::placeholder {
    color: #aaa;
  }
}


/* Animation du toast */
@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
